import { AmcAudience } from '../../../types/AmcAudiences';
import { PeopleOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

export default function AmcAudienceIcon(props: { amcAudience: AmcAudience | null }) {
    const { amcAudience } = props;

    interface StatusColorType {
        [key: string]: 'success' | 'warning' | 'error';
    }

    const audienceStatusColors: StatusColorType = {
        Success: 'success',
        Pending: 'warning',
        Error: 'error',
    };

    type MapType = {
        [id: string]: string;
    };
    const statusTooltip: MapType = {
        Success: 'Your Audience is available for use in a Campaign now.',
        Pending: 'Your Audience is being created and will be available in the DSP soon.',
        Error: amcAudience?.statusReason
            ? amcAudience.statusReason
            : 'Your Audience could not be created because of an unknown error.',
    };
    if (amcAudience?.statusMeaning) {
        let color = audienceStatusColors[amcAudience.statusMeaning];

        return (
            <Tooltip title={statusTooltip[amcAudience.statusMeaning]}>
                <IconButton onClick={() => {}}>
                    <PeopleOutlined color={color} />
                </IconButton>
            </Tooltip>
        );
    } else {
        return null;
    }
}
